module.exports = __webpack_public_path__ + "bc8241621a69a362b5c8b3b52ebf1c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_75.jpg
// module id = 1721
// module chunks = 5